module.exports = __webpack_public_path__ + "static/img/horn.c47dbb8f.gif";